import { createFileRoute } from '@tanstack/react-router'

import type { UserId } from '@beaded/models'

import { permQueries, userQueries } from 'lib/queries'

import User from 'pages/User'

export const Route = createFileRoute('/_auth/users/$id')({
  component: User,
  loader: ({ context: { queryClient }, params: { id } }) => {
    const userId = id as UserId
    void queryClient.prefetchQuery(userQueries.detail(userId))
    void queryClient.prefetchQuery(permQueries.byUser(userId))
  },
})
